import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
	static targets = [
		"rentalOption",
		"paypalForm",
		"stripeForm",
		"creditsForm"
	]

	connect() {
		this.select()
	}

	select() {
		const paypalRentalOption = this.paypalFormTarget.querySelector("#rental_option")
		paypalRentalOption.setAttribute("value", this.rentalOptionTarget.value)

		const stripeRentalOption = this.stripeFormTarget.querySelector("#rental_option")
		stripeRentalOption.setAttribute("value", this.rentalOptionTarget.value)

		const creditRentalOption = this.creditsFormTarget.querySelector("#rental_option")
		creditRentalOption.setAttribute("value", this.rentalOptionTarget.value)
	}
}
